 /* script for convert capitalize case of table text */
window.capitalize = (str) => {
    str = (str || "").toUpperCase();
    return str;
  }

  window.b64DecodeUnicode = (str) => {
    return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}

  window.b64EncodeUnicode = (str) => {
      return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
          function toSolidBytes(match, p1) {
              return String.fromCharCode('0x' + p1);
      }));
  }

window.showPopup = (e, ele)=>{
    const target = e.target;
    if(ele === "" || ele === undefined) ele = $(target).parent("tr");
    if(target.nodeName === "TD" && $(target).data("nopopup") === undefined){
        const title = $(ele).data("title");
        const message = $(ele).data("titleMessage");
        const datahref = $(ele).data("href");
        const dataedithref=$(ele).data("edithref");
        const datadeletehref=$(ele).data("deletehref");
        const dataundohref=$(ele).data("undohref");
        const datadetachlphref=$(ele).data("detach");
        const datattachlphref=$(ele).data("attach");
        const dataundostatus=$(ele).data("undostatus");
        const datarowsignature=$(ele).data("rowsignature");
        const dataAttachText=$(ele).data("attachtext");

        const modal = $("#myModal");
        try{
        const response = b64DecodeUnicode(title);
        modal.find(".modal-title").html(message);
        modal.find(".modal-body").html(response);
        if(datadeletehref!=undefined) {
            modal.find(".delete-button").attr("href", datadeletehref);
            modal.find(".delete-button").show();
        }
        if(dataedithref!=undefined) {
            modal.find(".edit-button").attr("href", dataedithref);
            modal.find(".edit-button").show();
        }
        if(dataundohref!=undefined) {
            modal.find(".undo-button").attr("href", dataundohref);
            modal.find(".undo-button").show();
        }

        if (datadetachlphref !== undefined) {
            modal.find(".save-button").attr("href", datadetachlphref);
            modal.find(".save-button").attr("id", 'detachcontainer');
            modal.find(".save-button").text(dataAttachText);
            modal.find(".save-button").show();
        } else if (datattachlphref !== undefined) {
            modal.find(".save-button").attr("href", 'javascript:void(0);');
            modal.find(".save-button").attr("id", 'attachcontainer');
            modal.find(".save-button").data("rowsignature", datarowsignature);
            modal.find(".save-button").text(dataAttachText);
            modal.find(".save-button").show();
        } else {
            modal.find(".save-button").hide();
        }


        if (dataundostatus!=undefined) {
            $("#displaystatus").text(dataundostatus);
        }


        modal.modal('show');

        }catch(err){
            console.error(err)
        }
    }

}

$("#myModal").on("hidden.bs.modal", function () {
    const modal = $("#myModal");
    modal.find(".edit-button").hide();
    modal.find(".delete-button").hide();
    modal.find(".undo-button").hide();
    modal.find(".save-button").hide();
});